import { render, staticRenderFns } from "./IframeDonatePage.vue?vue&type=template&id=1aca9f93&"
import script from "./IframeDonatePage.vue?vue&type=script&lang=js&"
export * from "./IframeDonatePage.vue?vue&type=script&lang=js&"
import style0 from "./IframeDonatePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports